export default __webpack_public_path__ + "static/media/Gauntlets of the Atlantean.171411fd.jpg";